import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpointUp } from '../utils/breakpoints';
import { triggerFlipOnScroll } from './gallery';

gsap.registerPlugin(ScrollTrigger);

let parallaxTimeline = null;

function initializeParallax() {
  // Clear any previous timelines if they exist
  if (parallaxTimeline) {
    ScrollTrigger.getById('footer-scroll-trigger')?.kill(true);
    parallaxTimeline.kill(true);
    parallaxTimeline = null;
  }

  // Check breakpoint
  if ($(window).width() >= 1024) {
    // Create a new timeline
    parallaxTimeline = gsap.timeline({
      scrollTrigger: {
        id: 'footer-scroll-trigger',
        trigger: ".footer",
        start: "top bottom",
        end: "bottom center",
        scrub: true,
        //markers: true
      }
    });
    parallaxTimeline.fromTo('.footer', {y: '20%'}, {y: 0})
  }
}

let lastWidth = $(window).width();
$(window).on('resize', function () {
  const currentWidth = $(window).width();
  if (currentWidth !== lastWidth) {
    lastWidth = currentWidth;
    setTimeout(() => {
      initializeParallax();
    }, 300)
  }
});

initializeParallax();

function instantScrollTo(selector) {
  if (!selector) return;
  setTimeout(() => {
    const element = document.querySelector(selector);
    console.log('element found: ', element)
    if (element) {
      window.scrollTo({ top: element.offsetTop, behavior: 'instant' });
    }
  }, 100);
}


function updateHash(hash) {
  history.pushState(null, null, hash);
}

document.addEventListener('DOMContentLoaded', () => {
  let isHashReload = false;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.getAttribute('href').startsWith('#')) {
      event.preventDefault();

      const targetId = target.getAttribute('href').substring(1);
      if (targetId === 'kontakti') {
        instantScrollTo(`#${targetId}`);
      } else {
        window.scrollTo({
          top: document.querySelector(`#${targetId}`).offsetTop,
          behavior: 'smooth'
        });
      }

      updateHash(`#${targetId}`);
    }
  });

  window.addEventListener('hashchange', () => {
    if (!isHashReload) {
      const hash = window.location.hash;

      if (hash === '#kontakti') {
        isHashReload = true;
        window.scrollTo({ top: window.scrollY, behavior: 'instant' });
        location.reload();
      }
    }
  });

  const handleHash = () => {
    const hash = window.location.hash;
    instantScrollTo(hash);
    ScrollTrigger.refresh();
  };

  window.addEventListener('popstate', handleHash);

  handleHash();

  const contactsElement = document.querySelector('#kontakti');

  if (contactsElement) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const isInView = entry.isIntersecting;
        const hash = '#kontakti';

        if (isInView) {
          if (window.location.hash !== hash) {
            updateHash(hash);
          }
        } else {
          if (window.location.hash === hash) {
            history.replaceState(null, null, window.location.pathname);
          }
        }
      });
    }, { threshold: [0.5] });

    observer.observe(contactsElement);
  }
});
